import React,{createRef, forwardRef,useImperativeHandle,useEffect, useState,useRef } from 'react';
import { Form,Modal} from "reactstrap";
import { Controller,useForm } from "react-hook-form";

import Swal from 'sweetalert2';
import API from '../../API';
import { TimeFormat,DateFormat, DateThai,DateFormatJSON,MobileFormat, NumberFormat,RootURL } from '../../Utils/Function';
import parse from 'html-react-parser'
import "react-datepicker/dist/react-datepicker.css";
import { classNames } from '@react-pdf-viewer/core';
import TopupCard from './TopupCard';
import TransactionCard from './TransactionCard';
const MemberInfoCard = forwardRef((props,ref) =>{
    const { register, handleSubmit, watch, reset, getValues,setValue, control, formState: { errors } } = useForm();
    
    const [ModalState,setModalState] = useState(false);
    const [_Detail,setDetail] = useState(null);
    const [_Card,setCard] = useState([]);
    const [_MemberID,setMemberID] = useState(null);
    const [GroupList,setGroupList] = useState([]);
    const [ViewMode,setViewMode] = useState(1);
    useEffect(() => {
        (async () => {
            
        })();

        return ()=>{ }
    }, []);
    
    useImperativeHandle(ref, () => ({
        Show(MemberID){
            setCard([]);
            setViewMode(1);
            setDetail(null);
            _LoadGroupList();
            if(MemberID != null){
                _Load(MemberID);
                setMemberID(MemberID);
                
            }else{
                setValue("Name",null);
                setValue("MemberCode",null);
                setValue("MemberType",null);
                setValue("MemberGroup",null);
                setValue("Remark",null);
                setModalState(true);
            }
            
            //setModalState(true);
        },

    }));
    
    const _Load = async(MemberID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Member/"+MemberID}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            const _MemberObj = res.data.Data.Member;
            setDetail(res.data.Data.Member);
            setCard(res.data.Data.Card);
            setValue("Name",_MemberObj.Name);
            setValue("MemberCode",_MemberObj.MemberCode.trim());
            setValue("MemberType",_MemberObj.MemberType);
            setValue("MemberGroup",_MemberObj.MemberGroup);
            setValue("Remark",_MemberObj.Remark);
            window.setTimeout(()=>{
                setModalState(true);
            },500);
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }
    const _LoadGroupList = async()=>{
        API({method : "get",url:"/Member/Group/List"}).then(res=>{
            if (res.status !== 200) {
                return;
            }

            if (!res.data.Status) {
                return;
            }
            setGroupList(res.data.Data);
        }).catch(res => {
            return;
        });
    }
    const _CardStatus = (data)=>{
        switch(data){
            case 0:return 'ยกเลิก';
            case 1:return 'ว่าง';
            case 2:return 'ใช้งาน';
            case 3:return 'เปลี่ยน';
            default : return 'ไม่ระบุ';
        }
    }
    const _Save = async()=>{
        if(getValues('MemberCode') == undefined || getValues('MemberCode') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ รหัสเลขประจำตัว'
            });
            return;
        }
        if(getValues('Name') == undefined || getValues('Name') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ ชื่อ'
            });
            return;
        }
        let _reqObj = {
            MemberID : (_Detail != null ? _Detail.MemberId:null),
            MemberCode: getValues('MemberCode'),
            Name: getValues('Name'),
            MemberType: Number(getValues('MemberType')),
            MemberGroupID:(getValues('MemberGroup') != null ? getValues('MemberGroup'):null),
            Remark: getValues('Remark'),
        }
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }

            API({method : 'post',url:'/Member/Save',data:_reqObj}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                _Load(res.data.Data.MemberId);
                setMemberID(res.data.Data.MemberId);
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกสำเร็จ',
                });
                //setModalState(false);
                //_ClearValuAction();
                if(props.update != undefined){
                    try{
                        props.update(res.data.Data);
                    }catch(e){
                        console.log(e);
                    }
                }
            }).catch(res => {
                if(res.response.data != undefined){
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message+' ['+res.code+']',
                    });
                }
            });
        });
    }

    const _Suspend = async()=>{
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการะงับบัตรหรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'ระงับ',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            Swal.showLoading();
            API({method : 'post',url:'/Staff/Card/Suspend/'+_Detail.MemberId,data:{Remark:""},headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                _Load(res.data.Data.MemberId);
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกสำเร็จ',
                });
                
            }).catch(res => {
                if(res.response.data != undefined){
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message+' ['+res.code+']',
                    });
                }
            });
        });
    }

    const _ChangeCard = async()=>{
        Swal.fire({
            title: 'รหัสบัตร',
            input: 'text',
            inputAttributes: {
                autocomplete: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'บันทึก',
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                Swal.fire({
                    icon: 'warning',
                    title: 'ต้องการเปลี่ยนบัตรหรือไม่ ?',
                    text : inputValue,
                    showCancelButton : true,
                    confirmButtonText: 'ถูกต้อง',
                    confirmButtonColor:'#d33',
                    cancelButtonText:'ยกเลิก'
                }).then((r)=>{
                    if(!r.isConfirmed){
                        return;
                    }
                    Swal.showLoading();
                    API({method : 'put',url:'/Staff/Card/Change/'+_Detail.MemberId+'/'+inputValue}).then(res=>{
                        if(!res.data.Status){
                            Swal.fire({
                                icon: 'error',
                                title: res.data.Message
                            });
                            return;
                        }
                        _Load(res.data.Data.MemberId);
                        Swal.fire({
                            icon: 'success',
                            title: 'บันทึกสำเร็จ',
                        });
                        
                    }).catch(res => {
                        if(res.response.data != undefined){
                            Swal.fire({
                                icon: 'error',
                                title: res.code,
                                text: res.response.data.Message
                            });
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: 'การเชื่อมต่อผิดพลาด',
                                text: res.message+' ['+res.code+']',
                            });
                        }
                    });
                });
            }
          });
    }
    
    return (
        <>
        <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
            <div className="modal-header">
                <h5 className="modal-title">ข้อมูลสมาชิก {(_Detail != null?_Detail.MemberCode:"")}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={()=>{setModalState(false)}}></button>
            </div>
            <div className='modal-body' style={{'minHeight':'500px'}}>
                <Form onSubmit={handleSubmit(_Save)} className='row g-3'>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>รหัสเลขประจำตัว</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control'  {...register("MemberCode", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>ชื่อ</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' {...register("Name", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>ประเภท</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="MemberType" control={control} rules={{required:false}} render={({field})=>(
                                <select className='form-control text-center' onChange={(e)=>field.onChange(e)} value={field.value} defaultValue={field.value} >
                                    <option value={0}>ไม่ระบุ</option>
                                    <option value={1}>นักเรียน</option>
                                    <option value={2}>บุคลากร</option>
                                </select>
                            )} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>กลุ่ม</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="MemberGroup" control={control} rules={{required:false}} render={({field})=>(
                                <select className='form-control text-center' onChange={(e)=>field.onChange(e)} value={field.value} defaultValue={field.value} >
                                    <option value={null} selected>ไม่ระบุ</option>
                                    {GroupList.map((v,i)=>{
                                        return <option key={i} value={v.MemberGroupId}>{v.MemberGroupName}</option>
                                    })}
                                </select>
                            )} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-5 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>ยอดเงินคงเหลือ</h3>
                        </div>
                        <div className='col-8'>
                            <h3><span className='text-danger'>{(_Detail != null ? NumberFormat(_Detail.Credit):"0.00")}</span> บาท</h3>
                        </div>
                    </div>
                    <div className='row justify-content-center mt-5 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>หมายเหตุ</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="Remark" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    <div className='row mt-3 mb-3'>
                         <div className='col-12'>
                            <div className='btn-group btn-xs'>
                                <button type="button" className={(ViewMode === 1 ? 'btn btn-info text-white active' : 'btn btn-secondary text-white')} onClick={() => { setViewMode(1) }}>ข้อมูลบัตร</button>
                                <button type="button" className={(ViewMode === 2 ? 'btn btn-info text-white active' : 'btn btn-secondary text-white')} onClick={() => { setViewMode(2); }}>ประวัติเติมเงิน</button>
                                <button type="button" className={(ViewMode === 3 ? 'btn btn-info text-white active' : 'btn btn-secondary text-white')} onClick={() => { setViewMode(3) }}>ประวัติชำระเงิน</button>
                                
                            </div>
                         </div>
                    </div>
                    {(ViewMode === 1 ? <>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <div className='table-responsive'>
                                <table className='table table-responseive'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>หมายเลขบัตร</th>
                                            <th className='text-center'>สถานะ</th>
                                            <th className='text-center'>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_Card.map((v,i)=>(
                                            <tr key={i}>
                                                <td className='text-center'>{v.CardNo}</td>
                                                <td className='text-center'>{_CardStatus(v.CardMode)}</td>
                                                <td className='text-center'></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    </>:"")}
                    {(ViewMode === 2 ?<TopupCard MemberID={_MemberID}></TopupCard>:"")}
                    {(ViewMode === 3 ?<TransactionCard MemberID={_MemberID}></TransactionCard>:"")}

                    <div className='row mt-4'>
                        <div className='col-12'>
                            <div className='btn-group btn-group-lg float-end'>
                                <button type='submit' className='btn btn-success text-white'>บันทึกข้อมูล</button>
                                <button type='button' className='btn btn-info text-white' onClick={()=>{_ChangeCard();}}>เปลี่ยนบัตร</button>
                                <button type='button' className='btn btn-danger text-white' onClick={()=>{_Suspend();}}>ระงับบัตร</button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </Modal>
        </>)
        
});

export default React.memo(MemberInfoCard)